import React, { useState } from 'react';
import { Input, Radio, Button, Empty } from 'antd';
import { EnvironmentOutlined, SearchOutlined, CloseOutlined, RightOutlined } from '@ant-design/icons';
import './LocationSelector.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Check } from 'lucide-react';

export const LocationSelector = ({ locations, onClose, onContinue }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredLocations = locations?.filter(loc =>
    loc.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    loc.address.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  const handleContinue = () => {
    if (selectedLocation && onContinue) {
      onContinue(selectedLocation);
    }
  };

  return (
    <>
      

      <div className="location-selector-wrapper">
        <div className="location-selector-container">
          {/* Header */}
          <div className="location-selector-header">
            <button className="location-selector-close-btn" onClick={onClose}>
              <CloseOutlined style={{ fontSize: 18 }} />
            </button>
            <div className="location-selector-header-content">
              <div className="location-selector-icon-wrapper">
                <EnvironmentOutlined />
              </div>
              <div className="location-selector-header-text">
                <h3>Select Location</h3>
                <p>Select the location where these tasks will be performed.</p>
              </div>
            </div>
          </div>

          {/* Search Bar */}
          <div className="location-selector-search">
            <Input
              size="large"
              placeholder="Search by title or address..."
              prefix={<SearchOutlined style={{ color: '#9ca3af' }} />}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              allowClear
            />
          </div>

          {/* Location List */}
          <div className="location-selector-list">
            {filteredLocations.length === 0 ? (
              <div className="location-selector-empty">
                <Empty description="No locations found" />
              </div>
            ) : 
                filteredLocations.map((location) => (
                  <div
                    key={location._id}
                    className={`location-card ${selectedLocation?._id === location._id ? 'location-card-selected' : ''}`}
                    onClick={() => setSelectedLocation(location)}
                  >
                    <div className="location-card-content">
                    
                      
                      <div className="location-card-info">
                        <div className="location-card-title">
                          {location.title}
                          {
                            selectedLocation?._id === location._id &&
                            <div
                              style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                background: '#10b981',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <Check size={12} style={{ color: 'white' }} />
                            </div>
                          }
                        </div>
                        
                        <div className="location-card-address">
                          <div className="location-icon">
                            <EnvironmentOutlined style={{color: "rgb(255, 122, 89)", fontSize:'18px'}} />
                          </div>
                          {/* <div> */}
                            <span>{location.address}</span> 
                            {/* <div style={{marginTop:'8px'}}>
                              <span className='cord'>{location.cords?.coordinates[0]}</span>  &nbsp;
                              <span className='cord'>{location.cords?.coordinates[1]}</span>
                            </div> */}
                          {/* </div> */}
                        </div>
                        
                      </div>

                      <div className="location-card-arrow">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </div>
                    </div>
                  </div>
                ))
            }
          </div>

          {/* Footer */}
          <div className="location-selector-footer">
            <div className="location-selector-footer-text">
              {selectedLocation ? (
                <span className="location-selector-footer-text-selected">
                  ✓ {selectedLocation.title} selected
                </span>
              ) : (
                <span>Select a location to continue</span>
              )}
            </div>
            <button
              className={!selectedLocation? "drawer-outlined-btn disabled-btn":"drawer-outlined-btn"}
              disabled={!selectedLocation}
              onClick={handleContinue}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
};